import Base from './Base';
import { ApiResponse } from '@/types/api';

class Session extends Base {
  async requestOTPCode(payload: { phoneNumber: string }) {
    const response = await this.apiClient.post<ApiResponse<void, void>>(
      '/sessions/request-otp',
      payload,
    );

    return response;
  }

  async confirmOTPCode(payload: { code: string; phoneNumber: string }) {
    const response = await this.apiClient.post<
      ApiResponse<{ accessToken: string; isNewUser: boolean }, void>
    >('/sessions/confirm-otp', payload);

    return response.data.data;
  }
}

export default Session;
